/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export enum C1Type {
  STORE_C1_TOKEN = 'STORE_C1_TOKEN',
  STORE_INIT = 'STORE_INIT',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
  ADD_USER_INFO = 'ADD_USER_INFO',
  LOGGING_OUT = 'LOGGING_OUT',
}

export type AllType = C1Type
